<template>
  <div @contextmenu.prevent @click="anti_screenshot_disable_click">
    <div id="AntiPrint" class="hidden">
      <h1 class="text-black">Nope! - Printing, Recording, Screenshotting or Sharing Simulations Is Not Allowed<br><br>Your
        Access Will Be Terminated If The TOS Is Broken<br><br>Contact Intellectual Point For More Information<br><br>
      </h1>
      <h1 class="text-black">{{ activeUserInfo.id }}</h1>
      <h1 class="text-black">{{ activeUserInfo.first_name }} {{ activeUserInfo.last_name }}</h1>
      <h1 class="text-black">{{ activeUserInfo.username }}</h1>
    </div>
    <div v-if="simulationData && simulationLegacyData" ref="cursor" class="vx-row simulation-page" id="LegacySimulationRenderer">
      <div class="vx-col lg:w-9/12 md:w-8/12 sm:w-5/5">
        <div class="vx-row ">
          <div class="vx-col w-full">
            <vx-card class="mb-3">
              <div class="flex justify-between items-center align-middle">
                <div class="flex items-center align-middle">
                  <img :src="simulationData.thumbnail" v-if="simulationData.thumbnail" width="40"
                       height="40" class="rounded shadow-md cursor-pointer block mr-3" draggable="false" alt=""/>
                  <vs-input v-if="enableEditMode" v-model="simulationData.name" class="ml-1"
                            style="min-width: 14vw"></vs-input>
                  <h2 v-else class="font-bold ml-2">{{ simulationData.name }}</h2>
                </div>
                <vs-button color="danger" icon-pack="feather" icon="icon-arrow-left"
                           @click="$router.push('/simulation/search')">Exit To Simulation Selector
                </vs-button>
              </div>
            </vx-card>
          </div>
        </div>
        <component :class="!simulationPaused && simulationAntiSkid || !simulationAntiSkid ? 'block' : 'hidden'"
                   :is="dynamicComponent"
                   :key="renderKey" ref="simulation"
                   :data="{simulation : simulationData, legacy: simulationLegacyData, options: simulationOptions}"
                   v-on:enable_mark_button="enable_mark_button"
                   v-on:simulation_full_correct="simulation_full_correct"
                   v-on:simulation_getting_there="simulation_getting_there"
                   v-on:simulation_update_options="simulation_update_options"/>
        <div :class="!simulationPaused && simulationAntiSkid || !simulationAntiSkid ? 'hidden' : 'block'"
             class="paused-overlay">
          <div class="flex items-center justify-center">
            <img src="https://cdn.discordapp.com/attachments/746242308084858900/826327906623684638/IP_Logo_White.png"
                 width="400" alt="IP Logo">
          </div>
          <h1 class="mt-10 font-bold text-center">You Are Currently Paused</h1>
          <h1 class="mt-4 font-light text-center">To Resume Tap In The Middle Of The Screen</h1>
        </div>
      </div>
      <div class="vx-col  lg:w-3/12 md:w-4/12 sm:w-5/5">
        <vx-card class="mb-5" title="Insights">
          <div class="mt-4">
            <div class="flex justify-between">
              <div class="flex flex-col ">
                <span class="mb-1">{{ simulationCurrentScore.name }}</span>
                <h4>{{ simulationCurrentScore.percent }}%</h4>
              </div>
              <div class="flex flex-col text-right">
                <br>
                <vs-input-number v-if="enableEditMode" min="0" v-model="simulationLegacyData.total_score"/>
                <h4 v-else>{{ simulationCurrentScore.display_score }}</h4>
              </div>
            </div>
            <vs-progress :color="simulationCurrentScore.color" :height="8"
                         :percent="simulationCurrentScore.percent"></vs-progress>
          </div>
        </vx-card>
        <vx-card class="mb-5" collapse-action title="Instructions">
          <div>
            <!-- simulation instructions -->
            <quill-editor v-if="enableEditMode" v-model="simulationData.instructions_content" ></quill-editor>
            <div v-else class="mb-6 instructions-show-render"
                 :class="!simulationPaused && simulationAntiSkid || !simulationAntiSkid ? 'block' : 'instructions-blur'"
                 v-html="simulationData.instructions_content"/>
            <!-- simulation demonstration video
            <vs-input v-if="enableEditMode" v-model="simulationData.demonstration_video_id"
                      class="w-full mt-10 mb-5"
                      label-placeholder="Demonstration Video ID"></vs-input>
            <vs-button v-if="!enableEditMode && simulationData.demonstration_video_id"
                       class="mt-3 font-bold  w-full"
                       color="primary"
                       icon="icon-film" icon-pack="feather" type="border"
                       @click="toggle_demonstration_video">
              {{
                showDemonstrationVideo === false ? 'Watch the Demonstration Video' : 'Hide the Demonstration Video'
              }}
            </vs-button> -->
          </div>
        </vx-card>
        <vx-card class="mb-5 pt-0" title="Actions">
          <div v-if="!enableEditMode">
            <vs-button v-if="!simulationComplete"
                       class="my-2 font-bold flex"
                       color="danger"
                       icon="icon-refresh-cw" icon-pack="feather" size="large" style="width: 100%; z-index: 1"
                       type="filled"
                       @click="reset_simulation">Reset Simulation
            </vs-button>
            <vs-button v-if="!simulationComplete && simulationOptions.showMarkButton" id="markBtn"
                       class="my-2 font-bold flex"
                       color="success"
                       icon="icon-check-circle" icon-pack="feather" size="large" style="width: 100%; z-index: 1"
                       type="filled"
                       @click="markSimulation">Submit Simulation
            </vs-button>
            <div v-if="!simulationComplete && !simulationOptions.showMarkButton" class="flex align-middle mt-5">
              <vx-tooltip text="The Simulation Will Be Automatically Submitted Once All Steps Are Completed">
              <feather-icon icon="InfoIcon" svgClasses="h-6 w-6 text-white" class="mr-1" />
              </vx-tooltip>
              <p class="ml-1 self-center+">Auto Submission Is On</p>
            </div>
            <vs-button v-if="simulationComplete"
                       class="my-2 font-bold flex"
                       color="danger"
                       icon="icon-refresh-cw" icon-pack="feather" size="large" style="width: 100%; z-index: 1"
                       type="filled"
                       @click="play_simulation_again">Play Simulation Again
            </vs-button>
            <vs-button v-if="simulationComplete" class="my-2 font-bold flex" color="success"
                       icon="icon-arrow-right-circle"
                       icon-pack="feather" size="large" style="width: 100%; z-index: 1" type="filled"
                       @click="next_simulation">Next Simulation
            </vs-button>

          </div>
          <vs-button
            v-else
            class="w-full font-bold text-lg mb-6"
            icon="icon-edit" icon-pack="feather" type="filled" color="success"
            @click="update_full_simulation">Update Simulation
          </vs-button>
          <div v-if="$acl.check('proctor')" class="flex items-center justify-start align-middle mt-6">
            <p class="mr-2">Admin Mode</p>
            <vs-switch class="mr-2" v-model="enableEditMode" color="success"></vs-switch>
            <p class="ml-2 mr-2">Anti-Skid</p>
            <vs-switch v-model="simulationAntiSkid" color="success"></vs-switch>
          </div>
        </vx-card>
      </div>


      <!--- DEMONSTRATION VIDEO  --->
      <div v-if="showDemonstrationVideo" class="movable-popup shadow-2xl rounded" ref="videoPlayerRef"
           :class="transitionOutDemonstrationVideo === true ? 'slideXLeftOut' : ''"
           style="z-index: 999999; background-color: transparent;">
        <movable class="movable-top border card-border flex justify-between" target="videoPlayerRef">
          <p class="mr-2 truncate">Playing Demonstration Video - Click Here to Drag Video Player</p>
        </movable>
        <div ref="movableVideo" style="margin-top: 25px">
          <!--- <hls-player
            player_class="rounded-b"
            source="https://simulations-vimeo-auth.rapid-edu.workesimulationSubmitPopuprs.dev/?id=523583106&token=6e2f12aeaa1a795026a81b2d35bcaac63358ee8a"></hls-player> --->
        </div>
        <div class="movableCloseBtn">
          <feather-icon @click="toggle_demonstration_video" icon="XCircleIcon"
                        svgClasses="w-6 h-6 text-white"></feather-icon>
        </div>
      </div>

      <!--- SIMULATION SUBMIT POPUP MESSAGE --->
      <vs-popup :active.sync="simulationSubmitPopup.active" class="pb-3" :title="simulationSubmitPopup.title">
       <div v-if="simulationSubmitPopup.type === 'warning'">
         <div class="flex justify-center mt-3 mb-5">
            <img src="https://cdn.discordapp.com/attachments/845520647710834708/845539048466284554/danger.png" width="150" alt="Check">
         </div>
         <h1 class="text-center font-bold my-6" style="font-size: 42px">{{simulationSubmitPopup.score}} / {{simulationLegacyData.total_score}}</h1>
         <h3 class="text-center font-light mb-3">You're Getting There! Keep Practicing To Get 100%</h3>
         <div class="flex justify-center mt-3">
           <vs-button class="mt-5 mb-5" color="warning" @click="simulationSubmitPopup.active = false">Try Again</vs-button>
         </div>
       </div>
        <div v-if="simulationSubmitPopup.type === 'complete'">
          <div class="flex justify-center mt-3 mb-5">
            <img src="https://cdn.discordapp.com/attachments/845520647710834708/845539218570084372/payment.png" width="150" alt="Check">
          </div>
          <h1 class="text-center font-bold my-6" style="font-size: 42px">{{simulationSubmitPopup.score}} / {{simulationLegacyData.total_score}}</h1>
          <h3 class="text-center font-light mb-3">Amazing Job! Simulation Complete</h3>
          <div class="flex justify-center mt-3">
            <vs-button class="mt-5 mb-5" color="success" @click="simulationSubmitPopup.active = false">Continue</vs-button>
          </div>
        </div>
      </vs-popup>

      <!--- USER DISPLAY INFO --->
      <div class="vx-col">
        <p class="mt-4" style="opacity: 85%">{{ activeUserInfo.first_name }} {{ activeUserInfo.last_name }} -
          {{ activeUserInfo.username }}</p>
      </div>
    </div>
    <div v-else>
      <div class="simple-spinner">
        <span></span>
      </div>
    </div>
  </div>
</template>
<script>
import 'quill/dist/quill.snow.css'
import {quillEditor} from 'vue-quill-editor'

export default {
  data () {
    return {
      componentFile: null,
      simulationData: null,
      simulationLegacyData: null,
      showDemonstrationVideo: false,
      transitionOutDemonstrationVideo: false,
      disableMarkButton: false,
      simulationComplete: false,
      renderKey: 0,
      currentAttempt: 0,

      showGettingThereDialog: false,
      showSimulationFullCorrect: false,

      simulationOptions: {
        showMarkButton: true
      },

      isUserProctor: false,
      enableEditMode: false,
      editDescriptionCounter: 0,

      simulationPaused: false,
      simulationAntiSkid: true,
      keyDown: false,

      simulationCurrentScore: {
        id: 1,
        name: 'Simulation Progress',
        color: 'success',
        percent: 0,
        display_score: ''
      },

      simulationSubmitPopup: {
        active: false,
        score: 0,
        title: 'Simulation Results',
        type: null
      }

    }
  },
  computed: {
    dynamicComponent () {
      // eslint-disable-next-line
      return () => import(`./templates/${this.simulationLegacyData.content_file}.vue`)
    },
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    simulation_update_options (data) {
      this.simulationOptions = data
    },
    start_simulation () {

      let trying = true
      setTimeout(() => {
        trying = false
      }, 30000)


      const vg_ready = resolve => {
        if (window.VGReady === true || trying === false) resolve()
        if (window.VGReady !== true) {
          setTimeout(() => vg_ready(resolve), 400)
        }
      }

      return new Promise(vg_ready)
    },
    get_legacy_data (id) {
      this.$http.get(`simulations/legacy/${id}`)
        .then(response => {
          if (response.status === 200) {
            this.componentFile = response.data.data.content_file
            this.simulationLegacyData = response.data.data
            this.simulationCurrentScore.percent = Math.round(0 / response.data.data.total_score * 100)
            this.simulationCurrentScore.display_score = `${`${0} / `}${response.data.data.total_score}`
          }
        }).catch(() => {
          this.$vs.notify({
            title: 'Error While Loading Simulation',
            text: 'Please ensure you have the course selected for the simulation you are trying to access',
            color: 'danger',
            position: 'top-right'
          })
          this.$router.push('/simulation/search')
        })
    },
    get_simulation_data (id) {

      this.$http.get(`simulations/${id}`)
        .then(response => {
          if (response.status === 200) {
            this.$vs.loading.close()

            this.simulationData = response.data.data

            this.start_simulation().then(() => {
              this.$VoriantGuard.sendActivityStart(response.data.data)
            })

            //Chose Simulation Type
            if (this.simulationData.type === 'legacy') {
              return this.get_legacy_data(response.data.data.id)
            }

            //No Simulation Type or Wrong Type
            this.$vs.notify({
              color: 'danger',
              title: 'Simulation Render Error',
              text: 'Something went wrong, Contact an admin.'
            })
            return this.$router.push({name: 'simulation-search'})

          }

        })
        .catch(() => {
          this.$vs.notify({
            title: 'Error While Loading Simulation',
            text: 'Please ensure you have the course selected for the simulation you are trying to access',
            color: 'danger',
            position: 'top-right'
          })
          this.$router.push('/simulation/search')
        })
    },
    simulation_offline_mode () {
      this.$vs.notify({
        color: 'danger',
        title: 'Offline Mode',
        text: 'This simulation was unable to connect to our progress server.',
        position: 'top-right'
      })
    },
    markSimulation () {
      if (this.disableMarkButton === true) {
        return this.$vs.notify({
          color: 'danger',
          title: 'Submission Cooldown',
          text: 'Please wait before re-marking your simulation',
          position: 'top-right'
        })
      }
      //Disable BTN
      this.disableMarkButton = true

      this.$vs.loading({
        background: '#187743',
        color: 'white',
        container: '#markBtn',
        scale: 0.45
      })

      //Send to Sim Template to Mark
      this.$refs.simulation.markSimulation()

    },
    simulation_full_correct (score) {

      if (window.VGReady !== false) {
        this.$VoriantGuard.sendSimulationSubmission({
          auth: window.activity_id,
          score
        })
        this.$VoriantGuard.sendSimulationComplete({
          auth: window.activity_id
        })
      } else {
        this.simulation_offline_mode()
      }

      this.$confetti.start({})

      setTimeout(() => {
        this.$vs.loading.close('#markBtn> .con-vs-loading')
        this.simulationComplete = true
      }, 1)


      this.simulationCurrentScore.percent = Math.round(score / this.simulationLegacyData.total_score * 100)
      this.simulationCurrentScore.display_score = `${`${score} / `}${this.simulationLegacyData.total_score}`

      setTimeout(() => {
        this.$confetti.stop()
      }, 3000)

      this.simulation_full_correct_sound.play()

      this.simulationSubmitPopup = {
        active: true,
        score,
        title: 'Amazing Job - Simulation Complete',
        type: 'complete'
      }
    },
    simulation_getting_there (score, dialog = true) {
      if (window.VGReady !== false) {
        this.$VoriantGuard.sendSimulationSubmission({
          auth: window.activity_id,
          score
        })
      } else {
        this.simulation_offline_mode()
      }

      setTimeout(() => {
        this.$vs.loading.close('#markBtn> .con-vs-loading')
        this.disableMarkButton = false
      }, 5000)

      this.simulationCurrentScore.percent = Math.round(score / this.simulationLegacyData.total_score * 100)
      this.simulationCurrentScore.display_score = `${`${score} / `}${this.simulationLegacyData.total_score}`

      this.simulation_getting_there_sound.play()

      this.currentAttempt++

      if (dialog) {
        this.simulationSubmitPopup = {
          active: true,
          score,
          title: 'You\'re Getting There - Try Again',
          type: 'warning'
        }
      }

    },
    enable_mark_button () {
      this.$vs.loading.close('#markBtn> .con-vs-loading')
      this.disableMarkButton = false
    },
    next_simulation () {
      return this.$router.push({name: 'simulation-search'})
    },
    reset_simulation () {

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Reset Simulation',
        text: 'Please confirm you want to reset the simulation. You will loose all of your progress.',
        accept: this.confirm_reset_simulation,
        acceptText: 'Reset'
      })

    },
    confirm_reset_simulation () {

      this.renderKey++
      this.simulationCurrentScore = {
        id: 1,
        name: 'Simulation Progress',
        color: 'success',
        percent: Math.round(0 / this.simulationLegacyData.total_score * 100),
        display_score: `${`${0} / `}${this.simulationLegacyData.total_score}`
      }

    },
    toggle_demonstration_video () {
      if (this.showDemonstrationVideo === false) {
        this.showDemonstrationVideo = true
        this.transitionOutDemonstrationVideo = false
      } else {
        setTimeout(() => {
          this.showDemonstrationVideo = false
        }, 350)
        this.transitionOutDemonstrationVideo = true
      }
    },
    send_simulation_start (data) {
      window.activity_id = data
      this.$VoriantGuard.sendSimulationPlay({
        auth: window.activity_id
      })
    },
    send_activity_start () {
      this.$VoriantGuard.sendActivityStart(this.simulationData)
    },
    update_full_simulation () {
      this.$vs.loading()

      this.update_simulation()
      this.simulation_legacy_update_data()

      this.$vs.notify({
        title: 'Updated Simulation Successfully',
        text: `Simulation ${this.simulationData.name} has been updated.`,
        color: 'success',
        position: 'top-right'
      })

    },
    update_simulation () {
      const pl = this.simulationData
      pl.status = this.simulationData.status === undefined ? 'active' : this.simulationData.status
      pl.difficulty = parseInt(this.simulationData.difficulty.id)

      if (pl.name === undefined) {
        return this.$vs.notify({
          title: 'Failed to update simulation',
          text: 'Please provide a Simulation Name',
          color: 'danger',
          position: 'top-right'
        })
      }
      this.$http.post(`simulations/${this.simulationData.id}`, pl)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while updating this simulation'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to update simulation',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    },
    simulation_legacy_update_data () {

      const pl = this.simulationLegacyData

      this.$http.post(`simulations/legacy/${this.simulationData.id}`, pl)
        .then(() => {
          this.$vs.loading.close()
        })
        .catch(exception => {
          this.$vs.loading.close()

          let error = 'An unknown error occurred while updating simulation properties'
          if (exception.response) {
            error = exception.response.data.error.description
          }

          return this.$vs.notify({
            title: 'Failed to update simulation properties',
            text: error,
            color: 'danger',
            position: 'top-right'
          })
        })
    },
    anti_ps_enable (e) {
      this.keyDown = false
      if (e.keyCode === 44) {
        this.$copyText('Taking Screenshots Is Not Allowed, Your Access Will Be Revoked If You Continue To Record, Screenshot or Share Simulations')
        e.preventDefault()
      }
    },
    anti_screenshot_enable (e) {
      this.keyDown = true
      if (e.keyCode === 123) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'E'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === 'I'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === 'J'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode === 'C'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.keyCode === '91'.charCodeAt(0) && e.keyCode === 'S'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.keyCode === '93'.charCodeAt(0) && e.keyCode === 'S'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'S'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'U'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'H'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'A'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'F'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'E'.charCodeAt(0)) {
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 'C'.charCodeAt(0)) {
        this.$copyText(' ')
        e.preventDefault()
      }
      if (e.keyCode === 91) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.keyCode === 92) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.keyCode === 93) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.ctrlKey && e.shiftKey) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.shiftKey && e.keyCode === 18) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.ctrlKey && e.keyCode === 18) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.keyCode === 224 && e.shiftKey) {
        this.simulationPaused = true
        e.preventDefault()
      }
      if (e.keyCode === 17) {
        e.preventDefault()
      }
      if (e.keyCode === 18) {
        e.preventDefault()
      }
    },
    anti_leave_window () {
      this.simulationPaused = true
    },
    anti_screenshot_disable_click () {
      if (this.simulationPaused === true && this.keyDown === false) {
        this.simulationPaused = false
      }
    },
    play_simulation () {
      this.get_simulation_data(this.$route.params.simulationId)
      this.$VoriantGuard.on('op:4011', () => {
        this.simulation_tab_err.play()
        this.$vs.dialog({
          title: 'New Simulation Started',
          text: 'You have opened a new simulation, terminating this one. You may only practice upto 1 simulation at a time.'
        })
        return this.$router.push({name: 'simulation-search'})
      })
      this.$VoriantGuard.on('op:4013', () => {
        this.send_activity_start()
      })
      this.$VoriantGuard.on('op:4012', () => {
        this.send_activity_start()
      })
      this.$VoriantGuard.on('event:simulation_start_failed', () => {
        const vg_reconnect = setInterval(() => {
          if (window.VGReady === true) {
            this.send_activity_start()
            clearInterval(vg_reconnect)
          }
        }, 500)
        setTimeout(() => {
          clearInterval(vg_reconnect)
        }, 5000)
      })
      this.$VoriantGuard.on('event:activity_started', (client, data) => {
        this.send_simulation_start(data.d)
      })
    },
    leave_simulation () {
      try {
        this.$VoriantGuard.sendActivityDestroy()
      } catch (e) {
        return false
      }

      this.simulationComplete = false
      this.disableMarkButton = false
      this.currentAttempt = 0

    },
    play_simulation_again () {
      this.renderKey++
      this.leave_simulation()
      this.play_simulation()
    }
  },
  mounted () {

    this.simulation_tab_err = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Notification.mp3')
    this.simulation_full_correct_sound = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Success.mp3')
    this.simulation_getting_there_sound = new Audio('https://sims-cdn.intellectualpoint.com/sounds/effect/Error_Notification.mp3')

    window.simulation_getting_there_sound = this.simulation_getting_there_sound
    window.simulation_full_correct_sound = this.simulation_full_correct_sound
    window.simulation_tab_err = this.simulation_tab_err

    this.wasSidebarOpen = this.$store.state.reduceButton
    this.$store.commit('TOGGLE_REDUCE_BUTTON', true)

    this.play_simulation()

    window.addEventListener('blur', this.anti_leave_window)

    if (this.$acl.check('proctor')) {
      this.simulationAntiSkid = false
      this.isUserProctor = true
      return
    }

    window.addEventListener('keydown', this.anti_screenshot_enable)
    window.addEventListener('keyup', this.anti_ps_enable)


  },
  beforeDestroy () {

    this.leave_simulation()

    this.simulationData = null
    this.simulationLegacyData = null
    this.componentFile = null

    window.removeEventListener('keydown', this.anti_screenshot_enable)
    window.removeEventListener('keyup', this.anti_ps_enable)
    window.removeEventListener('blur', this.anti_leave_window)

    if (!this.wasSidebarOpen) this.$store.commit('TOGGLE_REDUCE_BUTTON', false)

  },
  watch: {
    enableEditMode () {
      this.get_simulation_data(this.simulationData.id)
    }
  },
  components: {
    quillEditor
  }

}
</script>

<style lang="scss">

//Add Dynamic Importing

@import "@/views/simulations/legacy/css/Renderer.scss";

.ql-container {
  font-family: "Poppins", Helvetica, Arial, sans-serif;
  font-size: inherit!important;
}

.ql-snow .ql-editor {
  h1 {
    font-size: 2em!important;
  }
  h2 {
    font-size: 1.5em!important;;
  }
  h3 {
    font-size: 1.17em!important;;
  }
  h5 {
    font-size: 0.83em!important;;
  }
  h6 {
    font-size: 0.67em!important;;
  }


}


</style>
